"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.isInMigrationMode = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _AppNativeStorage = _interopRequireDefault(require("../../utils/AppNativeStorage"));

var _DataStore = _interopRequireDefault(require("./DataStore2"));

var _LogStore = _interopRequireDefault(require("./LogStore"));

var _config = _interopRequireDefault(require("../../../targets/cord_eurofh_teams/config.js"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../helpers/DeviceInfoHelper"));

var DATA_STORE_SCHEME_VERSION_KEY = '_datastore_scheme_version';
var isInMigrationMode = false;
exports.isInMigrationMode = isInMigrationMode;

var DataMigrator = /*#__PURE__*/function () {
  function DataMigrator() {
    (0, _classCallCheck2["default"])(this, DataMigrator);
  }

  (0, _createClass2["default"])(DataMigrator, null, [{
    key: "_upgradeIncrementallyFrom",
    value: function () {
      var _upgradeIncrementallyFrom2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(previousVersion) {
        var features, appInfo, logs, fcmToken, apnToken, deviceData, privateData, mergedPrivateData, dataToSet, permissionAskedBefore, logs2, handledSysMessaged;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("upgrading data store from old version ".concat(previousVersion, " incrementally by 1 step"));
                _context.t0 = previousVersion;
                _context.next = _context.t0 === 0 ? 4 : _context.t0 === 1 ? 12 : _context.t0 === 2 ? 29 : _context.t0 === 3 ? 55 : _context.t0 === 4 ? 66 : _context.t0 === 5 ? 72 : _context.t0 === 6 ? 78 : _context.t0 === 7 ? 82 : 85;
                break;

              case 4:
                _context.next = 6;
                return _DataStore["default"].getElementByPath('public.features', true);

              case 6:
                features = _context.sent;

                if (!features) {
                  _context.next = 11;
                  break;
                }

                (0, _values["default"])(features).forEach(function (feature) {
                  if (feature.additionalData && feature.additionalData.auth) {
                    feature.additionalData._auth = feature.additionalData.auth;
                    delete feature.additionalData.auth;
                  }
                });
                _context.next = 11;
                return _DataStore["default"].setSingleData('public.features', features, true, true);

              case 11:
                return _context.abrupt("break", 85);

              case 12:
                _context.next = 14;
                return _DataStore["default"].getElementByPath('public.application', true);

              case 14:
                appInfo = _context.sent;

                if (!appInfo) {
                  _context.next = 20;
                  break;
                }

                _context.next = 18;
                return _DataStore["default"].setSingleData('device.application', appInfo, true, true);

              case 18:
                _context.next = 20;
                return _DataStore["default"].removeData('public.application', true);

              case 20:
                _context.next = 22;
                return _DataStore["default"].getElementByPath('public.logs', true);

              case 22:
                logs = _context.sent;

                if (!logs) {
                  _context.next = 28;
                  break;
                }

                _context.next = 26;
                return _DataStore["default"].setSingleData('device.logs', logs, true, true);

              case 26:
                _context.next = 28;
                return _DataStore["default"].removeData('public.logs', true);

              case 28:
                return _context.abrupt("break", 85);

              case 29:
                _context.next = 31;
                return _DataStore["default"].getElementByPath('public.fcmtoken', true);

              case 31:
                fcmToken = _context.sent;
                _context.next = 34;
                return _DataStore["default"].getElementByPath('public.apntoken', true);

              case 34:
                apnToken = _context.sent;
                _context.next = 37;
                return _DataStore["default"].getElementByPath('device', true);

              case 37:
                deviceData = _context.sent;
                _context.next = 40;
                return _DataStore["default"].getElementByPath('private', true);

              case 40:
                privateData = _context.sent;
                mergedPrivateData = (0, _assign["default"])({}, privateData, deviceData);
                dataToSet = {};
                dataToSet['client.fcmtoken'] = fcmToken;
                dataToSet['client.apntoken'] = apnToken;
                dataToSet['private'] = mergedPrivateData; // TODO: add server.* if not yet present
                // the following code is not yet correct

                _context.next = 48;
                return _DataStore["default"].pathExists('server');

              case 48:
                if (_context.sent) {
                  _context.next = 50;
                  break;
                }

                dataToSet['server'] = {};

              case 50:
                _context.next = 52;
                return _DataStore["default"].setData(dataToSet, true);

              case 52:
                _context.next = 54;
                return _DataStore["default"].removeData('device', true);

              case 54:
                return _context.abrupt("break", 85);

              case 55:
                if (!_config["default"].isSafetureApp) {
                  _context.next = 65;
                  break;
                }

                permissionAskedBefore = _DeviceInfoHelper["default"].isAndroid();

                if (permissionAskedBefore) {
                  _context.next = 61;
                  break;
                }

                _context.next = 60;
                return _DataStore["default"].getElementByPath('private.tandc.permissions.ios_asked', true);

              case 60:
                permissionAskedBefore = _context.sent;

              case 61:
                _context.next = 63;
                return _DataStore["default"].setSingleData('private.tandc.permissions.asked', permissionAskedBefore, true, true);

              case 63:
                _context.next = 65;
                return _DataStore["default"].removeData('private.tandc.permissions.ios_asked', true);

              case 65:
                return _context.abrupt("break", 85);

              case 66:
                _context.next = 68;
                return _DataStore["default"].getElementByPath('private.logs', true);

              case 68:
                logs2 = _context.sent;
                _context.next = 71;
                return _LogStore["default"].setData(logs2);

              case 71:
                return _context.abrupt("break", 85);

              case 72:
                _context.next = 74;
                return _DataStore["default"].getElementByPath('private.tandc.handeledSysMessages', true);

              case 74:
                handledSysMessaged = _context.sent;
                _context.next = 77;
                return _DataStore["default"].setSingleData('private.sysMessages.handled', handledSysMessaged, true, true);

              case 77:
                return _context.abrupt("break", 85);

              case 78:
                if (!_DataStore["default"].pathExists('public.vrl_fitzukunft.certificateDate')) {
                  _context.next = 81;
                  break;
                }

                _context.next = 81;
                return _DataStore["default"].removeData('public.vrl_fitzukunft.certificateDate', true);

              case 81:
                return _context.abrupt("break", 85);

              case 82:
                _context.next = 84;
                return _DataStore["default"].removeData('public.tracking', true);

              case 84:
                return _context.abrupt("break", 85);

              case 85:
                return _context.abrupt("return", _promise["default"].resolve);

              case 86:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function _upgradeIncrementallyFrom(_x) {
        return _upgradeIncrementallyFrom2.apply(this, arguments);
      }

      return _upgradeIncrementallyFrom;
    }()
  }, {
    key: "migrate",
    value: function () {
      var _migrate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var previousSchemeVersion, upgradeNecessary, i;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('[migration] migrating data...');
                exports.isInMigrationMode = isInMigrationMode = true;
                previousSchemeVersion = null;
                _context2.prev = 3;
                _context2.next = 6;
                return _AppNativeStorage["default"].getValue(DATA_STORE_SCHEME_VERSION_KEY);

              case 6:
                previousSchemeVersion = _context2.sent;
                _context2.next = 11;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);

              case 11:
                _context2.prev = 11;
                // TODO: Change the if condition to the following lines not before May 2019
                // TODO: This is 6 months from now and enough time for all relevant clients to update
                // TODO: Please note: travel & care already uses the new condition
                // if (previousSchemeVersion && previousSchemeVersion < target.dataSchemeVersion) {
                upgradeNecessary = previousSchemeVersion && previousSchemeVersion < _config["default"].dataSchemeVersion;

                if (!upgradeNecessary) {
                  _context2.next = 26;
                  break;
                }

                i = previousSchemeVersion || 0;

              case 15:
                if (!(i < _config["default"].dataSchemeVersion)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 18;
                return DataMigrator._upgradeIncrementallyFrom(i);

              case 18:
                i++;
                _context2.next = 15;
                break;

              case 21:
                _context2.next = 23;
                return _AppNativeStorage["default"].saveValue(DATA_STORE_SCHEME_VERSION_KEY, _config["default"].dataSchemeVersion);

              case 23:
                console.log("[migration] data migration finished to scheme version ".concat(_config["default"].dataSchemeVersion));
                _context2.next = 33;
                break;

              case 26:
                if (previousSchemeVersion) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 29;
                return _AppNativeStorage["default"].saveValue(DATA_STORE_SCHEME_VERSION_KEY, _config["default"].dataSchemeVersion);

              case 29:
                console.log("[migration] no data migration necessary as it is a fresh installation ".concat(_config["default"].dataSchemeVersion));
                _context2.next = 33;
                break;

              case 32:
                console.log("[migration] Data already on current version ".concat(_config["default"].dataSchemeVersion));

              case 33:
                exports.isInMigrationMode = isInMigrationMode = false;

                _DataStore["default"].setMigrationDone();

                _context2.next = 43;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t1 = _context2["catch"](11);
                console.error('[migration] error', _context2.t1);
                exports.isInMigrationMode = isInMigrationMode = false;

                _DataStore["default"].setMigrationDone();

                return _context2.abrupt("return", _promise["default"].reject(new Error('')));

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 9], [11, 37]]);
      }));

      function migrate() {
        return _migrate.apply(this, arguments);
      }

      return migrate;
    }()
  }]);
  return DataMigrator;
}();

var _default = DataMigrator;
exports["default"] = _default;